export default "__VITE_ASSET__BU6Gq24I__"